
import { IIconProps } from './add'

interface IIconMapProps extends IIconProps{
  fill: string;
}

export const IconMap = ({ style = {}, cy, fill }: IIconMapProps) => {
  return (
    <svg
    height={20}
    width={20}
    viewBox="0 0 12 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    data-cy={`IconFiltersMap${cy}`}>
    <path d="M11.6667 0L11.56 0.02L8 1.4L4 0L0.24 1.26667C0.0999999 1.31333 0 1.43333 0 1.58667V11.6667C0 11.8533 0.146667 12 0.333333 12L0.44 11.98L4 10.6L8 12L11.76 10.7333C11.9 10.6867 12 10.5667 12 10.4133V0.333333C12 0.146667 11.8533 0 11.6667 0ZM8 10.6667L4 9.26V1.33333L8 2.74V10.6667Z" />
    </svg>
  )
}
